import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "components/Button";
import CodeInput from "components/FormControls/CharacterInputBoxes/NumericCodeInput";
import { TextError } from "components/Notifications";
import endpointMaker from "configuration/endpoints";
import request from "http/request";
import React from "react";
import { actions } from "redux/auth/authSlice";
import { useAppDispatch } from "redux/store";

type IProps = {
  onRemove?: () => void;
  setDialogOpened: (o: boolean) => void;
};
function RemoveMFA({ onRemove, setDialogOpened }: IProps) {
  const dispatch = useAppDispatch();
  const [code, setCode] = React.useState<string>();
  const [error, setError] = React.useState<string>();

  const onConfirm = () =>
    request
      .post(endpointMaker.account.mfaRemove(), { mfaCode: code })
      .then(() => {
        setDialogOpened(false);
        dispatch(actions.removeMFA());
        onRemove?.();
      })
      .catch((e) => setError(`MFA is not removed: ${e?.message}`));

  return (
    <Dialog
      open={true}
      onClose={() => setDialogOpened(false)}
      aria-labelledby="remove MFA">
      <DialogTitle>Remove MFA</DialogTitle>
      <DialogContent>
        {error && <TextError message={error} />}
        <CodeInput
          length={6}
          onChange={() => setError("")}
          value={code}
          setValue={setCode}
        />
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => setDialogOpened(false)}
          color="primary"
          data-qa="dialog_cancel">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          data-qa="dialog_confirm">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default RemoveMFA;
